import BaseAPI from './base'
import { apis, getApiUrl } from '../api-config'
/**
 * API xử lý học sinh lớp học
 */
class TopicAPI extends BaseAPI {}

export default new TopicAPI('v1/topics', 'Topic', getApiUrl(apis.TeacherAPI))
